import React, { Component } from 'react'
import styled from 'styled-components'

const InjectHtmlBlock = styled.div`
  a {
    color: #1768c9;
  }
`

class StencilLinkStyling extends Component {

  render() {

    return (
        <InjectHtmlBlock>
          {this.props.children}
        </InjectHtmlBlock>
      )
  }
}

export default StencilLinkStyling
